const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var AmericanExpress24 = function AmericanExpress24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.983 3v9.787H9.97l-.283.398-.276-.399H6.206v3.163h3.206l.276-.399.283.399h2.004v-.681a1.98 1.98 0 0 0 .637-.117v.842h1.461v-.404l.277.404h5.958c.233-.061.46-.146.675-.255V21H3v-9.255h.92l.187-.437h.321l.161.443h7.026v-.405l.277.405h1.966v-.244c.02.024.052.035.084.046.028.01.056.02.076.037.022.02.051.03.08.039.03.01.059.02.08.039a.503.503 0 0 0 .239.038h1.44l.16-.437h.321l.16.437h1.966v-.398l.321.437h1.379V8.577h-1.5v.443l-.283-.443h-1.279v.554l-.244-.554h-2.364a.52.52 0 0 0-.119.02.5.5 0 0 1-.119.019c-.055 0-.094.023-.14.05a.63.63 0 0 1-.159.072c-.03.01-.06.02-.1.039v-.2h-6.77l-.211.515-.2-.52H5.082v.554l-.238-.554h-1.29L3 9.94V3h17.983zM3 11.225h.52l.2-.444h1.04l.189.444h.52l-.946-2.133h-.604L3 11.225zm17.983 4.514.017.01v-2.963h-.017c-.005.391-.035 2.95 0 2.953zm-.675-.748H19.2v.437h1.04a.659.659 0 0 0 .72-.68.553.553 0 0 0-.636-.6h-.482a.205.205 0 0 1 0-.403h.919l.2-.438h-1.058a.651.651 0 0 0-.72.643c0 .398.238.598.642.598h.482a.193.193 0 0 1 .186.122c.01.024.014.05.013.077.039.16-.044.244-.2.244zm-1.966 0h-1.08v.437h1.042a.664.664 0 0 0 .72-.68c0-.4-.239-.6-.643-.6H17.9a.205.205 0 0 1 0-.403h.925l.2-.438H17.95a.657.657 0 0 0-.725.643.556.556 0 0 0 .642.598h.482a.221.221 0 1 1 0 .443h-.006zm-1.4-1.285v-.438H15.28v2.121h1.662v-.443h-1.207v-.437h1.162v-.432h-1.162v-.399h1.201l.006.028zm-2.725 0a.243.243 0 0 1 .277.244c0 .116-.077.238-.277.238h-.603v-.52l.603.038zm-.603.925h.244l.636.758h.604l-.72-.803a.637.637 0 0 0 .554-.636.663.663 0 0 0-.72-.682h-1.107v2.121h.481l.028-.758zm-1.279-.643a.255.255 0 0 1-.282.277h-.643v-.554h.604a.287.287 0 0 1 .321.283v-.006zm-1.4-.72v2.121h.475v-.72h.643a.707.707 0 0 0 .764-.72.698.698 0 0 0-.726-.725l-1.157.044zm-.737 2.121h.603l-.841-1.08.841-1.04h-.603l-.52.68-.521-.68H8.57l.842 1.04-.842 1.042h.598l.52-.682.51.72zm-1.8-1.661v-.05h.011l-.01.05zm0-.05v-.388h-1.66v2.122h1.66v-.443h-1.19v-.438h1.157v-.454H7.208v-.399h1.19zm9.734-3.716.841 1.285h.637V9.092h-.481v1.401l-.117-.199-.791-1.202h-.637v2.127h.476V9.78l.072.183zm-2.082-.039.16-.443.156.443.205.482h-.715l.194-.482zm.842 1.324h.52L16.5 9.092h-.643l-.919 2.127h.52l.2-.443h1.04l.195.47zm-2.248 0 .002-.005h.014l-.016.005zm.002-.005.203-.438h-.111a.553.553 0 0 1-.554-.598v-.045a.552.552 0 0 1 .554-.598h.52v-.47h-.553a.957.957 0 0 0-1.002 1.04v.067a.931.931 0 0 0 .943 1.042zm-1.802.005h.482v-2.11h-.47v2.088l-.012.022zm-1.04-1.662c.199 0 .276.117.276.238a.244.244 0 0 1-.277.244h-.592v-.52l.604.038h-.012zm-.36.92h-.219l-.036.714h-.482V9.092h1.107a.664.664 0 0 1 .704.731.642.642 0 0 1-.554.643l.72.803h-.604l-.636-.764zm-1.124-.92v-.088h.01l-.01.088zm0-.088v-.405H8.659v2.127h1.66v-.443H9.13v-.443h1.163v-.438H9.129v-.398h1.19zm-3.644 1.75h.438l.603-1.723v1.723H8.2V9.092h-.77l-.481 1.446-.504-1.446h-.797v2.127h.476V9.502l.553 1.745zM4.107 9.9l.16-.443.161.443.2.482H3.88l.227-.482z",
      fill: "#2E70B5",
    })
  );
};
AmericanExpress24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var AmericanExpress32 = function AmericanExpress32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z",
      fill: "#006FCF",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.093 19.902v-8.65l15.397.014v2.39l-1.78 1.9 1.78 1.92v2.44h-2.841l-1.51-1.666-1.5 1.673-9.546-.02z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.122 18.953v-6.75h5.723v1.555h-3.87v1.056h3.778v1.53h-3.778v1.036h3.87v1.573h-5.723z",
      fill: "#016FD0",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m23.817 18.953 3.166-3.378-3.166-3.371h2.45l1.936 2.139 1.94-2.14h2.347v.054l-3.1 3.318 3.1 3.283v.095h-2.37l-1.97-2.16-1.949 2.16h-2.384z",
      fill: "#016FD0",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.811 3.574h3.712l1.303 2.96v-2.96h4.582l.79 2.217.793-2.217h3.498v8.65H14l3.811-8.65z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m18.515 4.514-2.995 6.744h2.054l.564-1.35H21.2l.565 1.35h2.105l-2.983-6.744h-2.372zm.257 3.88.898-2.147.897 2.147h-1.795z",
      fill: "#016FD0",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.842 11.257V4.513l2.887.01 1.486 4.146 1.495-4.156h2.78v6.744l-1.789.016V6.64l-1.688 4.617h-1.632l-1.723-4.633v4.633h-1.816z",
      fill: "#016FD0",
    })
  );
};
AmericanExpress32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: AmericanExpress24,
  32: AmericanExpress32,
};
export function AmericanExpress(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'AmericanExpress' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
